var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-stories',{attrs:{"id":"onboarding","value":_vm.show,"start":_vm.controller?.story,"items":_vm.script||[],"skipable":_vm.skipable||_vm.testing},on:{"seen":_vm.seen,"close":(i) => _vm.toggle(false, i)}})
}
var staticRenderFns = []

export { render, staticRenderFns }